import {handleActions} from 'redux-actions';
import * as actions from './actions';
import {arrayToObjectById} from "../../../../infrastructure/helpers";

const defaultState = {
    textTemplatesLoadError: null,
    textTemplatesLoading: false,
    textsTemplatesByIds: {},
    textsGroupsByIds: {},
    defaultTextTemplatesGroup: null,

    themesTemplatesLoadError: null,
    themesTemplatesLoading: false,
    themesTemplatesByIds: {},
    themesGroupsByIds: {},
    defaultThemeTemplate: null,
    defaultThemeGroup: null
};

const reducer = handleActions(
    new Map([
        // Text templates
        [actions.loadTextsTemplatesRequest,
            (state, action) => {
                return {...state, textTemplatesLoading: true, textTemplatesLoadError: null};
            }],
        [actions.loadTextsTemplatesFailed,
            (state, action) => {
                return {...state, textTemplatesLoading: false, textTemplatesLoadError: action.payload};
            }],
        [actions.loadTextsTemplatesSuccess,
            (state, action) => {
                return {
                    ...state,
                    textTemplatesLoading: false,
                    textsTemplatesByIds: {...state.textsTemplatesByIds, ...arrayToObjectById(action.payload.templates)},
                    textsGroupsByIds: {...state.textsGroupsByIds, ...arrayToObjectById(action.payload.groups)},
                    defaultTextTemplatesGroup: action.payload.defaultTextTemplatesGroup,
                };
            }],

        // Themes
        [actions.loadThemesRequest,
            (state, action) => {
                return {...state, themesTemplatesLoading: true, themesTemplatesLoadError: null};
            }],
        [actions.loadThemesFailed,
            (state, action) => {
                return {...state, themesTemplatesLoading: false, themesTemplatesLoadError: action.payload};
            }],
        [actions.loadThemesSuccess,
            (state, action) => {
                return {
                    ...state,
                    themesTemplatesLoading: false,
                    themesTemplatesByIds: {...state.themesTemplatesByIds, ...arrayToObjectById(action.payload.templates)},
                    themesGroupsByIds: {...state.themesGroupsByIds, ...arrayToObjectById(action.payload.groups)},
                    defaultThemeTemplate: action.payload.defaultThemeTemplate,
                    defaultThemeGroup: action.payload.defaultThemeGroup,
                };
            }],
    ]),
    defaultState
);

export default reducer;
